<template>
    <el-container>
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" :inline="true">
                        <el-form-item label="用户名/护照名/中文名" v-if="showSearch.studentName" prop="studentName" style="width: 15%">
                            <el-input v-model="searchData.studentName" placeholder="用户名/护照名/中文名" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="意向项目" prop="interestCourse" v-if="showSearch.interestCourse" style="width: 15%" >
                            <el-select
                                v-model="searchData.interestCourse"
                                clearable
                                placeholder="意向项目"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option value="GGC/HSK" label="通用汉语/HSK"></el-option>
                                <el-option value="OBC" label="商务汉语"></el-option>
                                <el-option value="CCY" label="青少中文"></el-option>
                                <el-option value="CUL" label="中国文化课程"></el-option>
                                <el-option value="other" label="其他"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="注册方式" v-if="showSearch.source" clearable prop="source">
                            <el-select
                                v-model="searchData.source"
                                clearable
                                placeholder="注册方式"
                                size="small"
                                @change="changeSearchOrg"
                                style="width: 100%"
                            >
                                <el-option label="PC端注册" :value="1"></el-option>
                                <el-option label="Phone端注册" :value="2"></el-option>
                                <el-option label="后台添加" :value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生源机构" v-if="showSearch.originSource" clearable prop="originSource">
                            <el-select
                                v-model="searchData.originSource"
                                clearable
                                placeholder="生源机构"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                v-for="item in agentsList"
                                :key="item.agentCode"
                                :label="item.agentDes"
                                :value="item.agentCode"
                            ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="注册日期" v-if="showSearch.createTime" clearable prop="createTime">
                            <el-date-picker
                                v-model="searchData.createTimeStart"
                                type="date"
                                placeholder="起始日期"
                                value-format="yyyy-MM-dd"
                                size="small"
                            />
                            <span> 至 </span>
                            <el-date-picker
                                v-model="searchData.createTimeEnd"
                                type="date"
                                placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                size="small"
                            />
                        </el-form-item>
                        <el-form-item label="购买商品类别" prop="mallCommodityCategory" style="width:15%">
                            <el-cascader
                                expand-trigger="hover"
                                change-on-select="true"
                                size="small"
                                clearable
                                :options="categoryOptions"
                                v-model="showSearch.mallCommodityCategory"
                                style="width: 100%"
                                :props="{ value: 'ccId', label: 'ccName'}"
                                @change="changeCategory">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="购买商品名称" v-if="showSearch.mallCommodityName" clearable prop="mallCommodityName" style="width: 15%" >
                            <el-input v-model="searchData.mallCommodityName" placeholder="购买商品名称" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="所学课程类别" v-if="showSearch.courseCategory" clearable prop="courseCategory">
                            <el-select
                                v-model="searchData.courseCategory"
                                clearable
                                placeholder="所学课程类别"
                                size="small"
                                @change="changeSearchOrg"
                                style="width: 100%"
                            >
                                <!-- <el-option label="PC端注册" :value="1"></el-option>
                                <el-option label="Phone端注册" :value="2"></el-option>
                                <el-option label="后台添加" :value="4"></el-option> -->
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所学课程名称" v-if="showSearch.courseName" clearable prop="courseName" style="width: 14%" >
                            <el-input v-model="searchData.courseName" placeholder="所学课程名称" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="所学课程状态" v-if="showSearch.courseStudyStatus" clearable prop="courseStudyStatus">
                            <el-select
                                v-model="searchData.courseStudyStatus"
                                clearable
                                placeholder="所学课程状态"
                                size="small"
                                @change="changeSearchOrg"
                                style="width: 100%"
                            >
                                <!-- <el-option label="PC端注册" :value="1"></el-option>
                                <el-option label="Phone端注册" :value="2"></el-option>
                                <el-option label="后台添加" :value="4"></el-option> -->
                            </el-select>
                        </el-form-item>
                <br>
                <el-form-item>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-search"
                        @click="onSubmit()"
                    >查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
                <el-table-column prop="userName" label="用户名" width="220" fixed="left" ></el-table-column>
                <el-table-column prop="passportLastName" label="护照名" width="165"  v-if="loginOrgCode == 'blcuonline'" :formatter="f_passportName"></el-table-column>
                <el-table-column prop="interestCourse" label="意向项目" width="120" :formatter="interestCourseFormat" v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="source" label="注册方式" width="90"  :formatter="sourceFormat" v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="agentDes" label="生源" width="160"  v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="createTime" label="注册日期"  width="160" :formatter="createTimeFormat"></el-table-column>
                <el-table-column prop="courseName" label="购买商品名称"  width="160"></el-table-column>
                <el-table-column prop="createTime" label="所学课程名称"  width="160" :formatter="createTimeFormat"></el-table-column>
                <el-table-column prop="createTime" label="课程状态"  width="160" :formatter="createTimeFormat"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px"
            ></el-pagination>
        </el-main>
    </el-container>
</template>

<script>
import https from '@/https.js';
import validate from '@/api/validate.js';
import {dateFormat} from '@/api/utils.js';
const form = {
    orgCode: '',
    userName: '',
    phone: '',
    realName: '',
    sex: 0,
    birthday: '',
    originSource: '',
    email: '',
    education: '',
    province: '',
    city: '',
    district: '',
    qq: '',
    passportFirstName: '',
    passportLastName: '',
    address: '',
    password: '',
    confirmPassword: ''
};
const importStudentForm = {
    orgCode: '',
    banch: '',
    file: null
};
export default {
    data() {
        return {
          agentsList: [],
          categoryOptions: [],
          courseCategoryList:[],
          checkList: ["userName", "orgCode", "originSource", "source", "banch"],
          showSearch: {
            userName: true,
            studentName: true,
            interestCourse: true,
            mallCommodityCategory:true,
            mallCommodityName:true,
            courseCategory:true,
            courseName:true,
            courseStudyStatus:true,
            status: false,
            source: true,
            originSource: true,
            createTime: true,
          },
          createTime: '',
            loginOrgCode: '',
            headerData: {Authentication: localStorage.getItem('token')},
            nationalityList: [],
            org: [],
            isBanch: false,
            orgType: '',
            orgCode: '',
            loading: true,
            form: JSON.parse(JSON.stringify(form)),
            searchData: {
                userName: '',
                phone: '',
                realName: '',
                orgCode: '',
                status: '',
                email: '',
                source: '',
                banch: '',
                originSource: '',
                qq: '',
                createTimeStart: '',
                createTimeEnd: '',
                page: 1,
                size: 0
            },
            multipleSelection: [],
            orgBanchList: [],
            banchList: [],
            rules: {
                userName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                    {validator: validate.validateUserName, trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入电话', trigger: 'blur'},
                    {validator: validate.validatePhone, trigger: 'blur'}
                ],
                orgCode: [{required: true, message: '请选择机构', trigger: 'blur'}],
                password: [{validator: validate.validatePassword, trigger: 'blur'}],
                realName: [{max: 50, message: '长度不得超过50个字符', trigger: 'blur'}],
                email: [{validator: validate.validateEmail, trigger: 'blur'}],
                qq: [{validator: validate.validateQQ, trigger: 'blur'}],
                  passportFirstName: [
                    {max: 50, message: '长度不得超过100个字符', trigger: 'blur'}
                  ],
              passportFirstName: [
                {max: 50, message: '长度不得超过100个字符', trigger: 'blur'}
              ],
              address: [
                // {max: 100, message: '长度不得超过100个字符', trigger: 'blur'}
              ]
            },
            rulesImpoort: {
                orgCode: [{required: true, message: '请选择机构', trigger: 'change'}],
                banch: [{required: true, max: 50, message: '请输入：长度不得超过50个字符', trigger: 'blur'}],
                file: [{required: true, message: '请选择文件', trigger: 'change'}]
            },
            total: 0,
            pageSize: 10,
            currentPage: 1,
            addStaff: false,
            staffData: [],
            isUpdate: false,
            title: '添加用户',
            area: [],
            city: [],
            district: [],
            showImport: false,
            fileList: [],
            importStudentForm: {
                orgCode: '',
                banch: '',
                file: null
            },
            uploadUrl: this.https.baseURL + '/managerStudent/importStudent',
            isShowChooseBtn: true,
            detailDialog: {
                show: false,
                data: {
                    orgName: '北京语言大学网络教育学院'
                }
            }
        };
    },
    methods: {
      createTimeFormat(row, column, cellValue, index) {
        if(cellValue) {
          return dateFormat(cellValue).substr(0,16);
        }
      },
      changeSearchOrg() {
          let orgCode = '';
          this.orgBanchList = [];
          this.searchData.banch = '';
          this.isBanch = false;
          if(this.searchData.source == 16) {
            this.isBanch = true;
          }
          if(this.searchData.orgCode && this.searchData.source == 16) {
            orgCode = this.searchData.orgCode;
          }
        if(this.orgType != 1 && this.searchData.source == 16) {
          orgCode = this.orgCode;
        }
        for(let banch of this.banchList) {
          if(banch.orgCode == orgCode) {
            this.orgBanchList = banch.banchList;
            return;
          }
        }
        },
        selectOrg() {
            https
                .fetchGet('/managerOrganization/getOrganizationList', '', 'from')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.org = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error('网络错误');
                });
        },
        handleSelectionChange(val) {
            this.multipleSelection = []; 
            for (let index in val) {
                this.multipleSelection[index] = val[index].userName;
            }
        },
        onSubmit(val) {
            if (val) {
                this.searchData.page = val;
            } else {
                this.searchData.page = 1;
                this.currentPage = 1;
            }
            this.searchData.size = this.pageSize;
            let params = this.searchData;
            this.loading = true;
            https
                .fetchPost('/managerStudent/search', JSON.parse(JSON.stringify(params)), 'json')
                .then((data) => {
                    let code = data.data.code;
                    if (code == '200') {
                        this.staffData = data.data.data;
                        this.total = data.data.total;
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error('数据加载失败');
                });
        },
        handleSizeChange() {},
        handleCurrentChange(val) {
            this.onSubmit(val);
        },
        searchArea() {
            https
                .fetchGet('/managerAreas/getAreaTree', '', 'form')
                .then((data) => {
                    let code = data.data.code;
                    if (code == '200') {
                        this.area = data.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error('数据加载失败');
                });
        },
        changeOrgAdd(val) {},
        changeProvince(val) {
            this.city = [];
            this.form.city = '';
            this.form.district = '';
            let nowProvince = this.area.find((t) => t.code == val);
            this.city = nowProvince.children;
        },
        changeCity(val) {
            this.district = [];
            this.form.district = '';
            let nowCity = this.city.find((t) => t.code == val);
            this.district = nowCity.children;
        },
        handleStudentClose() {
            this.resetUploadInfo();
        },
        sourceFormat(row, column, cellValue, index) {
            if (cellValue != null) {
                let result = '';
                switch (cellValue) {
                    case 16:
                    case 4:
                    case 8:    
                        result = '后台添加';
                        break;
                    case 1:
                        result = 'PC端注册';
                        break;
                    case 2:
                        result = 'APP注册';
                        break;
                }
                return result;
            } else {
                return cellValue;
            }
        },
        interestCourseFormat(row, column, cellValue, index) {
            if (cellValue != null) {
                let result = '';
                switch (cellValue) {
                    case 'GGC/HSK':
                        result = '通用汉语/HSK';
                        break;
                    case 'OBC':
                        result = '商务汉语';
                        break;
                    case 'CCY':
                        result = '青少中文';
                        break;
                    case 'CUL':
                        result = '中国文化';
                        break;
                    case 'other':
                    result = '其他';
                    break;
                }
                return result;
            } else {
                return cellValue;
            }
        },

      getNationality() {
        https.fetchGet('/managerNationality/getList', {}, 'form').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              this.nationalityList = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      },
      f_passportName(row, column, cellValue, index) {
        if(!row.passportFirstName) {
          row.passportFirstName = "";
        }
        if(!row.passportLastName) {
          row.passportLastName = "";
        }
        return row.passportFirstName + " " +row.passportLastName;
      },
      selectBanch() {
        let params = {
          orgCode: '',
          source: ''
        };
        https.fetchPost('/managerStudent/getBanchList', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                if(data.data.data) {
                  this.banchList = data.data.data;
                }
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      },
      searchAgents() {
        let params = {
        };
        this.https.fetchPost('/managerRole/agents', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.agentsList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      getMallCommodityCategoryList() {
        let params = {
        };
        this.https.fetchPost('/managerRole/agents', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.agentsList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      addRule(prop, rule) {
        this.$set(this.rules, prop, rule);
      },
        //endregion 详情
    },
  filters: {
    dateFormatFilter(val) {
      return dateFormat(val).substr(0,10);
    },
    dateFormatFilter1(val) {
      return dateFormat(val).substr(0,16);
    },
    sexFilter(val) {
      if(val == 0) {
        return '保密';
      }
      if(val == 1) {
        return '女';
      }
      if(val == 2) {
        return '男';
      }
    }
  },
  watch: {
    'loginOrgCode': {
      immediate: true,
      handler (newVal) {
        if (this.loginOrgCode == 'blcuonline') {
          this.addRule('userName', [{ required: true, message: '请输入用户名', trigger: 'blur' }]);
          this.addRule('phone', []);
          this.addRule('email', [{ required: true, message: '请输入邮箱', trigger: 'blur' },{validator: validate.validateEmail, trigger: 'blur'}]);
        } else {
          this.addRule('userName', [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {validator: validate.validateUserName, trigger: 'blur'}
          ]);
          this.addRule('phone', [
            {required: true, message: '请输入电话', trigger: 'blur'},
            {validator: validate.validatePhone, trigger: 'blur'}
          ]);
          this.addRule('email', [{validator: validate.validateEmail, trigger: 'blur'}],);
          
        }

      }
    },
  },
  created: function () {
        this.loginOrgCode = this.$store.state.orgCode;
        this.orgType = this.$store.state.orgType;
        this.orgCode = this.$store.state.orgCode;
        this.onSubmit();
        this.searchArea();
        this.selectOrg();
        this.selectBanch();
        this.getNationality();
        this.searchAgents();
    }
};
</script>

<style scoped>
.el-form-item{
    margin-bottom: 0px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
#detailDialog .el-form-item {
    margin-bottom: 0;
}
    .line {
        text-align: center;
    }
</style>
